import type { OrgData } from "@p0security/shared/types/tenant/index";
import type { PropsWithChildren } from "react";

import { useFirebaseAuth } from "../hooks/useFirebaseAuth";
import type { TenantData } from "../types/auth";
import { UserAuthContext } from "./UserAuthProvider";

type Props = {
  tenant: TenantData;
  orgData: OrgData | undefined;
  orgSlug: string | undefined;
};

export const FirebaseUserProvider: React.FC<PropsWithChildren<Props>> = ({
  children,
  tenant,
  orgData,
  orgSlug,
}) => {
  const auth = useFirebaseAuth(tenant, orgData, orgSlug);

  return (
    <UserAuthContext.Provider value={auth}>{children}</UserAuthContext.Provider>
  );
};
